import React from 'react';
import { Loader2, MapPin } from 'lucide-react';
import { Modal } from '../Modal';

interface Props {
    noteText: string;
    setNoteText: (v: string) => void;
    actionLoading: boolean;
    onSave: () => void;
    onClose: () => void;
}

export const NoteModal: React.FC<Props> = ({ noteText, setNoteText, actionLoading, onSave, onClose }) => {
    return (
        <Modal title="Nota Operativa" onClose={() => !actionLoading && onClose()}>
            <div className="space-y-4">
                <textarea
                    className="w-full h-40 p-4 bg-slate-50 border border-slate-200 rounded-xl text-sm font-medium text-slate-800 outline-none focus:ring-2 ring-blue-500 resize-none"
                    placeholder="Descrivi l'evento rilevante..."
                    value={noteText}
                    onChange={e => setNoteText(e.target.value)}
                    disabled={actionLoading}
                    autoFocus
                />
                {actionLoading && (
                    <div className="flex items-center gap-2 p-3 bg-blue-50 text-blue-700 rounded-lg text-xs font-semibold">
                        <Loader2 size={14} className="animate-spin" />
                        Caricamento in corso...
                    </div>
                )}
                <div className="flex justify-end gap-2 pt-2">
                    <button
                        type="button"
                        onClick={onClose}
                        disabled={actionLoading}
                        className="px-5 py-2.5 text-sm font-semibold text-slate-500 hover:bg-slate-100 rounded-lg transition-colors"
                    >
                        Annulla
                    </button>
                    <button
                        onClick={onSave}
                        disabled={actionLoading || !noteText.trim()}
                        className="px-6 py-2.5 bg-blue-600 hover:bg-blue-500 text-white text-sm font-semibold rounded-lg shadow-sm disabled:opacity-50 transition-all flex items-center gap-2"
                    >
                        {actionLoading ? <Loader2 size={16} className="animate-spin" /> : <MapPin size={16} />}
                        Salva nel Log
                    </button>
                </div>
            </div>
        </Modal>
    );
};
